/**
 * @generated SignedSource<<8855149af7139d76f081f27d58f62b25>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AdminMembersReportDiscussionsTabStatisticsCardsQuery$variables = {
  id: string;
  startDate?: string | null;
};
export type AdminMembersReportDiscussionsTabStatisticsCardsQuery$data = {
  readonly node: {
    readonly __typename: "OrganizationMembership";
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"MemberReportCommentsStatisticsCardFragment" | "MemberReportMessagesSentStatisticsCardFragment" | "MemberReportReactionsStatisticsCardFragment">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type AdminMembersReportDiscussionsTabStatisticsCardsQuery = {
  response: AdminMembersReportDiscussionsTabStatisticsCardsQuery$data;
  variables: AdminMembersReportDiscussionsTabStatisticsCardsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "startDate"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "kind": "Variable",
  "name": "startDate",
  "variableName": "startDate"
},
v5 = [
  (v4/*: any*/)
],
v6 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "allTime",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sinceYesterday",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminMembersReportDiscussionsTabStatisticsCardsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "args": (v5/*: any*/),
                "kind": "FragmentSpread",
                "name": "MemberReportMessagesSentStatisticsCardFragment"
              },
              {
                "args": (v5/*: any*/),
                "kind": "FragmentSpread",
                "name": "MemberReportCommentsStatisticsCardFragment"
              },
              {
                "args": (v5/*: any*/),
                "kind": "FragmentSpread",
                "name": "MemberReportReactionsStatisticsCardFragment"
              }
            ],
            "type": "OrganizationMembership",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AdminMembersReportDiscussionsTabStatisticsCardsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "messagesSentReport",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "entities",
                    "value": [
                      "ChatChannel"
                    ]
                  },
                  {
                    "kind": "Literal",
                    "name": "kinds",
                    "value": [
                      "channel_message_sent"
                    ]
                  },
                  (v4/*: any*/)
                ],
                "concreteType": "GenericReportingResponse",
                "kind": "LinkedField",
                "name": "userActivityReport",
                "plural": false,
                "selections": (v6/*: any*/),
                "storageKey": null
              },
              {
                "alias": "commentsReport",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "entities",
                    "value": [
                      "CurriculumItem",
                      "Assignment",
                      "AssignmentSubmission",
                      "Lesson",
                      "Task",
                      "Post"
                    ]
                  },
                  {
                    "kind": "Literal",
                    "name": "kinds",
                    "value": [
                      "commented"
                    ]
                  },
                  (v4/*: any*/)
                ],
                "concreteType": "GenericReportingResponse",
                "kind": "LinkedField",
                "name": "userActivityReport",
                "plural": false,
                "selections": (v6/*: any*/),
                "storageKey": null
              },
              {
                "alias": "reactionsReport",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "kinds",
                    "value": [
                      "reaction"
                    ]
                  },
                  (v4/*: any*/)
                ],
                "concreteType": "GenericReportingResponse",
                "kind": "LinkedField",
                "name": "userActivityReport",
                "plural": false,
                "selections": (v6/*: any*/),
                "storageKey": null
              }
            ],
            "type": "OrganizationMembership",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "12f63dd3b249a43c57ad09d37d212f75",
    "id": null,
    "metadata": {},
    "name": "AdminMembersReportDiscussionsTabStatisticsCardsQuery",
    "operationKind": "query",
    "text": "query AdminMembersReportDiscussionsTabStatisticsCardsQuery(\n  $id: ID!\n  $startDate: String\n) {\n  node(id: $id) {\n    __typename\n    ... on OrganizationMembership {\n      id\n      ...MemberReportMessagesSentStatisticsCardFragment_4sOHZa\n      ...MemberReportCommentsStatisticsCardFragment_4sOHZa\n      ...MemberReportReactionsStatisticsCardFragment_4sOHZa\n    }\n    id\n  }\n}\n\nfragment MemberReportCommentsStatisticsCardFragment_4sOHZa on OrganizationMembership {\n  commentsReport: userActivityReport(startDate: $startDate, kinds: [commented], entities: [CurriculumItem, Assignment, AssignmentSubmission, Lesson, Task, Post]) {\n    allTime\n    sinceYesterday\n  }\n}\n\nfragment MemberReportMessagesSentStatisticsCardFragment_4sOHZa on OrganizationMembership {\n  messagesSentReport: userActivityReport(startDate: $startDate, kinds: [channel_message_sent], entities: [ChatChannel]) {\n    allTime\n    sinceYesterday\n  }\n}\n\nfragment MemberReportReactionsStatisticsCardFragment_4sOHZa on OrganizationMembership {\n  reactionsReport: userActivityReport(startDate: $startDate, kinds: [reaction]) {\n    allTime\n    sinceYesterday\n  }\n}\n"
  }
};
})();

(node as any).hash = "70708c654f5517142ec0ca70412fd312";

export default node;
